import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppA3DocConnection } from '../models/appA3DocConnection.model';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';
import { LivesSessionHelper } from '../helper/livesSessionHelper';


//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable({ providedIn: 'root' })
export class AppA3DocConnectionService extends HttpClientBaseService implements IServiceBase<AppA3DocConnection> {

    constructor(
        _http: HttpClient,
        private _livesSession: LivesSessionHelper,
    ) {
        super(_http, '/a3doc/connection/', '', false);

    }
    getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppA3DocConnection>> {
        throw new Error('Method not implemented.');
    }

    getAllModels(): Observable<AppA3DocConnection[]> {
        throw new Error('Method not implemented.');

    }

    public createModel(data: Partial<AppA3DocConnection>): Observable<AppA3DocConnection> {
        const url = `${AppConfig.settings.apiServerPE.apiUrl}a3doc/connection`;
        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });


        let sendData = {
            "deviceId": "TESTPC-WinUser",
            "deviceType": 0,
            "devicePlatform": 98,
            "environment": this._livesSession.EnvironmentId,
            ...data
        }

        // Realizar la petición PATCH y devolver el resultado como un Observable
        return this.http.post<AppA3DocConnection>(url, sendData, { headers: headers });
    }

    public updateModel(id: string, data: Partial<AppA3DocConnection>): Observable<AppA3DocConnection> {
        const url = `${AppConfig.settings.apiServerPE.apiUrl}a3doc/connection?a3docConnection=${id}`;
        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });


        // Realizar la petición PATCH y devolver el resultado como un Observable
        return this.http.patch<AppA3DocConnection>(url, data, { headers: headers });
    }

    getModel(): Observable<AppA3DocConnection> {
        const environment = this._livesSession.EnvironmentId
        const url = `${AppConfig.settings.apiServerPE.apiUrl}a3doc/connection?identifier=${environment}`;
        // Crear los headers con la clave API
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
        });


        // Realizar la petición PATCH y devolver el resultado como un Observable
        return this.http.get<AppA3DocConnection>(url, { headers: headers });
    }




}
